import React from "react";

const ContactSection = ({ fontStyleMap }) => {
  const contacts = [
    {
      name: "Младоженец",
      phone: "070 000 000",
    },
    {
      name: "Невеста",
      phone: "071 000 000",
    },
  ];

  return (
    <section className="fw-section fw-contact">
      <div className="fw-contact-inner">
        <h2
          className="fw-section-title"
          style={{ ...(fontStyleMap.subtitle || {}) }}
        >
          Контакт
        </h2>
        <p
          className="fw-contact-text"
          style={{ ...(fontStyleMap.body || {}) }}
        >
          Контактирајте не за сите дополнителни информации и детали.
        </p>
        <div className="fw-contact-cards">
          {contacts.map((contact) => (
            <div key={contact.name} className="fw-contact-card">
              <div className="fw-contact-icon" />
              <div className="fw-contact-details">
                <div className="fw-contact-name">{contact.name}</div>
                <a href={`tel:${contact.phone}`} className="fw-contact-phone">
                  {contact.phone}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactSection;

